export interface Booking {
  addons?: AddonObj[];
  amount_paid: number;
  booking_name: string;
  booking_note: string;
  booking_phone_number: string;
  booking_status: BookingStatus;
  booking_status_label: string;
  booking_type: BookingTypes;
  category_id?: number;
  coupon_code: string;
  coupon_discount: number;
  end: Date | string;
  fixed_booking?: FixedBooking;
  id: number;
  is_single_booking: boolean;
  is_used_coupon?: boolean;
  is_user_made?: boolean;
  has_match?: boolean;
  match_id?: number | string | null;
  match_date: string;
  match_end_time: string;
  match_time: string;
  net_amount: number;
  no_show: boolean;
  payment_actual_amount: number;
  payment_currency: any;
  payment_expected_amount: number;
  payment_method: PaymentMethods;
  payment_method_label: string;
  payment_order_duration: number;
  payment_paid_status: number;
  pitch: Pitch;
  pitch_id: number;
  resourceId: number;
  stadium_id: number;
  start: Date | string;
  total_addons_amount: number;
  user_id: number | string | null;
  coach: Coach | null;
  is_coaching_booking: boolean;
  is_issued_invoice: boolean;
  final_price: number;
  credit_amount: number;
  is_use_credit: boolean;
  duration: BookingDuration;
  start_date: string;
  end_date: string;
  category_name?: string;
  category_name_ar?: string;
  user_email: string;
  booking_payment?: BookingPayment;
  payment_method_key?: string;
  integration_id?: number | string;
}

export enum BookingTypes {
  UserMadeBooking = 1,
  OwnerMadeBooking = 2,
  VirtulBooking = 3,
}

export enum BookingDuration {
  Duration60 = 60,
  Duration90 = 90,
  Duration120 = 120,

  Duration150 = 150,
  Duration180 = 180,

  Duration210 = 210,
  Duration240 = 240,

  Duration270 = 270,
  Duration300 = 300,

  Duration330 = 330,
  Duration360 = 360,

  Duration390 = 390,
}

export enum LogActions {
  CREATED = 'created',
  UPDATED = 'updated',
}

export enum BookingStatus {
  Confirmed = 1,
  Pending = 2,
  Cancelled = 3,
  OutDate = 4,
  PendingPaymentAproval = 6,
}

export interface PaymentCurrency {
  discount: number;
  tag: string;
  tag_ar: string;
  title: string;
}
export interface ActionLog {
  id: number;
  action: LogActions;
  created_at: string;
  new_action_data: {
    match_date: string;
    match_time: string;
    booking_status: BookingStatus;
    booking_type: BookingTypes;
    amount_paid: number;
    booking_name: string;
    booking_phone_number: number;
    payment_actual_amount: string;
    payment_expected_amount: number;
    payment_order_duration: number;
  };
  user_data: {
    role: string;
    sub_role: number;
    name: string;
    id: number;
  };
}

interface Pitch {
  id: number;
  is_stackable: number;
  label: string; // Fixed typo from 'lable' to 'label'
  min_players: number;
  pitch_size: number;
  price: number;
  price_60: number;
  price_90: number;
  price_120: number;
  stadium_id: number;
  virtual_pitch_child1: number;
  virtual_pitch_child2: number;
  virtual_pitch_child3: number;
  virtual_pitch_child4: number;
}

export interface PhoneCode {
  body_length: number;
  code: string;
  country_id: number;
  mask: string;
  phone_mask: string;
  tag: string;
}

export interface ItemInReactSelect {
  label: string;
  label_ar?: string;
  id: number;
}

export interface paymentMethodOfStadium {
  label: string;
  id: number;
  value: number;
}

export enum PaymentMethods {
  Cash = 1,
  Tap = 5,
  ApplePay = 11,
}

export enum PaymentMethodKeys {
  cash = 'cash',
  bank_transfer = 'bank_transfer',
  card_pos = 'card_pos',
  custom = 'custom',
  paid_at_stadium = 'paid_at_stadium',
}

export interface FixedBooking {
  amount_paid?: number;
  bookings_count?: number;
  created_at?: string;
  day_of_week?: number;
  duration?: number;
  first_match_date?: string;
  id?: number;
  is_expiring_soon?: boolean;
  last_match_date?: string;
  owner_booking?: string;
  payment_method?: PaymentMethods;
  pitch_id?: number | string;
  stadium_id?: number;
  updated_at?: string;
  user_booking?: number;
}

export interface changedData {
  match_date?: string;
  match_time?: string;
  booking_status?: BookingStatus;
  booking_type?: BookingTypes;
  booking_name?: string;
  booking_phone_number?: string;
  amount_paid?: number;
  payment_actual_amount?: number;
  payment_expected_amount?: number;
  payment_order_duration?: number;
}

export interface userDataInLogs {
  role: string;
  name: string;
  id: number;
}
export interface AddonObj extends Record<string, any> {
  id: number; // 137
  zoho_integration_id?: number;
  zoho_item_id?: string; // ""
  name: string; // "Water"
  name_ar?: string | null; // null
  description?: string | null; // null
  description_ar?: string | null; // null
  image?: string | null; // null
  source: string; // "tools"
  original_cost_per_one: number; // 10
  count: number | any;
  total_price: number;
  created_at: string;
  updated_at: string;
}

export interface phoneCode {
  body_length: number;
  code: string;
  country_id: number;
  mask: string;
  phone_mask: string;
  tag: string;
}
export interface Coach {
  id: number;
  name: string;
  image: string;
}

export interface BookingPayment {
  id: number;
  mark_as_paid: boolean;
  proof_of_payment: string | null;
  bank_name: string | null;
  transaction_id: string | null;
  paid_at_stadium: boolean | null;
  payment_method_key: string | null;
  notes: string | null;
  stadium_custom_payment_method: {
    id: number;
  };
}
